import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DownloadFormA from "../FormA/DownloadFormA.component";
import { getEmployeeFormAHistoryByID } from "app/_services/UserManagement/EmployeeService";
import { employeeFormAFields, initialEmployeeFormA } from "./Constant";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

function ViewEmployeeFormAHistory() {
  const { id } = useParams();

  const [data, setData] = useState({
    ...initialEmployeeFormA,
  });

  useEffect(() => {
    if (!id) return;

    getEmployeeFormAHistoryByID(id).then((response) => {
      if (!response?.data?.data?.dataJson) return;
      const historyData = JSON.parse(response.data.data.dataJson);

      setData((prev) => ({
        ...prev,
        ...historyData,
        startDateAtMines: historyData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: historyData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: historyData.dateOfSeparation?.slice(0, 10) || "",
        siteType: response.data.data.site?.siteType || "",
        mineName: response.data.data.site?.name || "",
        mineCode: response.data.data.site?.siteId || "",
        fullName: `${historyData.firstName || ""} ${historyData.lastName || ""}`,
        profilePicture: historyData.profilePicture
          ? `${URL_CONFIG.IMG_URL}${historyData.profilePicture}`
          : "",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          { name: "Employee", path: "/user-management/employee" },
          { name: "View Employee Form A History", path: "#" },
        ]}
      />
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">View Employee Form A History</h3>
          </Card.Title>
          <DownloadFormA fieldsObj={employeeFormAFields} data={data} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default ViewEmployeeFormAHistory;
